import { render, staticRenderFns } from "./PersonalizationValues.vue?vue&type=template&id=fa3a3912&scoped=true"
import script from "./PersonalizationValues.vue?vue&type=script&lang=js"
export * from "./PersonalizationValues.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationValues.vue?vue&type=style&index=0&id=fa3a3912&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa3a3912",
  null
  
)

export default component.exports